import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function AddFile({
  color = 'icon.primary',
  fill = 'transparent',
  strokeWidth = 1.25,
  ...props
}) {
  return (
    <IconBase viewBox='0 0 18 19' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d={
          'M10.4357 10.277H6.62311C6.42598 10.277 6.24186 10.1786 6.13245 10.0146L5.30506 ' +
          '8.77084C5.19543 8.6061 5.0105 8.50733 4.81263 8.50781H2.17947C1.52807 8.50781 1 ' +
          '9.03588 1 9.68728V15.5846C1 16.236 1.52807 16.7641 2.17947 16.7641H10.4357C11.0871 ' +
          '16.7641 11.6152 16.236 11.6152 15.5846V11.4565C11.6152 10.8051 11.0871 10.277 10.4357 10.277Z'
        }
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d={
          'M2.1875 8.50737V7.3279C2.1875 6.6765 2.71557 6.14844 3.36697 6.14844H9.2643C9.91571 6.14844 ' +
          '10.4438 6.6765 10.4438 7.3279V10.2766'
        }
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M15.3996 4.25059H10.0938'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M12.7506 1.60156V6.9074'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

AddFile.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.number,
}

export default AddFile
